import { Spin } from 'antd';
import React, { Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import FacilitatorDashboard from './dashboard';
import Projects from './project';
import Borrowers from './borrower';
import Investors from './investor';
import Investment from './investment';
import Validation from './validation';
import Profile from './profile';
import withAdminLayout from '../../layout/withAdminLayout';

const Facilitator = React.memo(() => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route index path="/*" element={<FacilitatorDashboard />} />
        <Route path="pages/*" element={<FacilitatorDashboard />} />
        <Route path="project/*" element={<Projects />} />
        <Route path="borrower/*" element={<Borrowers />} />
        <Route path="investor/*" element={<Investors />} />
        <Route path="investment/*" element={<Investment />} />
        <Route path="validation/*" element={<Validation />} />
        <Route path="profile/*" element={<Profile />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Facilitator);
